export const FETCH_CONTACTS = 'FETCH_CONTACTS';
export const CREATE_CONTACT = 'CREATE_CONTACT';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT';
// news constants
export const FETCH_NEWS = 'FETCH_NEWS';
export const CREATE_NEWS = 'CREATE_NEWS';
export const UPDATE_NEWS = 'UPDATE_NEWS';
export const DELETE_NEWS = 'DELETE_NEWS';
// comments constants
export const FETCH_COMMENTS = 'FETCH_COMMENTS';
export const CREATE_COMMENT = 'CREATE_COMMENT';
export const UPDATE_COMMENT = 'UPDATE_COMMENT';
export const DELETE_COMMENT = 'DELETE_COMMENT';
// courses constants
export const FETCH_COURSES = 'FETCH_COURSES';
export const CREATE_COURSE = 'CREATE_COURSE';
export const UPDATE_COURSE = 'UPDATE_COURSE';
export const DELETE_COURSE = 'DELETE_COURSE';
// students constants
export const AUTH = 'AUTH';
export const LOGOUT = 'LOGOUT';
//teacher constants
export const AUTHTEACHER = 'AUTHTEACHER';
export const LOGOUTTEACHER = 'LOGOUTTEACHER';
export const SAVE__LOCAL__STORAGE__DATA = 'SAVE__LOCAL__STORAGE__DATA';
export const REMOVE__LOCAL__STORAGE__DATA = 'REMOVE__LOCAL__STORAGE__DATA';